import { Services } from '@sigma-frontend-libs/commons'

import { serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services.credentials,

      has: {
        clone: false,
        filter: false
      },

      formClass: ''
    })
  ]
}
